const months = [
    { name: 'január', value: '01' },
    { name: 'február', value: '02' },
    { name: 'március', value: '03' },
    { name: 'április', value: '04' },
    { name: 'május', value: '05' },
    { name: 'június', value: '06' },
    { name: 'július', value: '07' },
    { name: 'augusztus', value: '08' },
    { name: 'szeptember', value: '09' },
    { name: 'október', value: '10' },
    { name: 'november', value: '11' },
    { name: 'december', value: '12' },
];

export const resultTableMixin = {
    data() {
        return {
            dataFields: [
                { name: "id", visible: false },
                { name: "year", visible: true, groupIndex: 0,
                    // calculateCellValue: function (data) {
                    //     return parseInt(data.jobMadeDate.substring(0, 4));
                    // }
                },
                { name: "jobMadeDate", caption: "Dátum", alignment: "center", dataType: "date", 
                    calculateCellValue: function (data) {
                        const month = data.jobMadeDate.substring(5, 7);
                        const result = months.find(item => item.value === month);
                        return data.jobMadeDate.substring(0, 4) + " " + result.name;
                }
                }, // right, left
                { name: "partsWeight", caption: "Keletkezett alkatrész",
                    calculateCellValue: function (data) {
                        return valuePercentage(data.partsWeight, data.partsWeight);
                    }
                },
                { name: "metarialWasteWeight", caption: "Elsődleges hulladék",
                    calculateCellValue: function (data) {
                        return valuePercentage(data.metarialWasteWeight, data.partsWeight);
                    }
                },
                { name: "metarialRestWeight", caption: "Keletkezett maradék",
                    calculateCellValue: function (data) {
                        return valuePercentage(data.metarialRestWeight, data.partsWeight);
                    }
                },
                { name: "usedRestWeight", caption: "Felhasznált maradék",
                    calculateCellValue: function (data) {
                        return valuePercentage(data.usedRestWeight, data.partsWeight);
                    }
                },
                { name: "secondaryWasteWeight", caption: "Felhalmozott maradék",
                    calculateCellValue: function (data) {
                        return valuePercentage(data.secondaryWasteWeight, data.partsWeight);
                    }
                },
                { name: "totalWasteWeight", caption: "Összes veszteség",
                    calculateCellValue: function (data) {
                        return valuePercentage(data.totalWasteWeight, data.partsWeight);
                    }
                },
                { name: "usedMetarialWeight", caption: "Felhasznált anyagmennyiség",
                    calculateCellValue: function (data) {
                        return valuePercentage(data.usedMetarialWeight, data.partsWeight);
                    }
                },
            ]
        }
    },
}
